










import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'FIcon'
})
class FIcon extends Vue {
  @Prop() readonly path!: string
}

export default FIcon
